import { ApiLambdalerAuthHeaderWithRequestActorSchema } from '@eigtech/lambdaler-api-gateway-types';
import { z } from 'zod';
import { DocumentCornSchema, InspectionCornSchema, InspectionEntityCornSchema } from '../base.js';
import { PartialMediaMetadataSchema } from '../base/mediaMetadata.js';
import { DocumentSchema } from '../entities/document.js';
export const UpdateDocumentBodySchema = z.object({
    description: z.string().optional(),
    fileName: z.string().optional(),
    labels: z.array(z.string()).optional(),
    metadata: PartialMediaMetadataSchema.optional(),
    title: z.string().optional(),
});
export const UpdateDocumentApiSchema = {
    params: z.object({
        entityId: InspectionEntityCornSchema,
        inspectionId: InspectionCornSchema,
        documentId: DocumentCornSchema,
    }),
    query: z.object({}),
    headers: ApiLambdalerAuthHeaderWithRequestActorSchema,
    body: UpdateDocumentBodySchema,
    response: DocumentSchema.omit({ s3Key: true }).extend({ signedUrl: z.string().url() }),
};
export const UpdateDocumentRequestSchema = UpdateDocumentApiSchema.params
    .merge(UpdateDocumentApiSchema.body)
    .merge(UpdateDocumentApiSchema.headers);
